import { ErrorPage } from "./ErrorPage.page";

export function ComingSoonPage() {
  return <ErrorPage variant="comingSoon" />;
}
